import { PLANNER_PAGES, PLANNERS_PAGES } from "./pages"

const PLANNER_PATHS: string[] = Object.keys(PLANNER_PAGES)
const PLANNERS_PATHS: string[] = Object.keys(PLANNERS_PAGES)

export const routing = (route: string, location: string, orderId?: string, back: boolean = false, page?: string) => {
  let path = route
  const endOfPath = location.split("/").pop()

  const addOrderRoute = orderId && !back
  if (addOrderRoute) {
    if (!path.endsWith("/")) path += "/"

    path += `${orderId}`
  }

  const paths = [...(orderId ? PLANNER_PATHS : PLANNERS_PATHS)]
  if (!back && typeof page !== "string" && endOfPath && paths.includes(endOfPath)) {
    if (path.endsWith("/")) path = path.slice(0, -1)
    return path + "/" + endOfPath
  }

  if (page) {
    if (path.endsWith("/")) path = path.slice(0, -1)

    return path + "/" + page
  }

  return path
}
